/**
 * Converts snake_case role names to Title Case for display
 * Example: "full_access" -> "Full Access"
 */
export const formatRoleNameForDisplay = (roleName: string): string => {
  if (!roleName) return '';
  return roleName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Converts Title Case role names to snake_case for backend
 * Example: "Full Access" -> "full_access"
 */
export const formatRoleNameForBackend = (roleName: string): string => {
  if (!roleName) return '';
  return roleName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
};

/**
 * Check if role name is in snake_case format
 */
export const isSnakeCaseFormat = (roleName: string): boolean => {
  return /^[a-z0-9_]+$/.test(roleName);
};
